module.exports = __webpack_public_path__ + "media/components/util/logos/vecteezy-logo--orange-on-white-a09d207a47a35a4fcae4ec802ea1da45.svg";